import instance from './instance';

const LEASE_LOG_BASE_URL = '/lease-log';

function getLeaseLogs(leaseId) {
  return instance.get(`${LEASE_LOG_BASE_URL}/${leaseId}`);
}

export default getLeaseLogs;
